// ShellApi.ts — the calls the app shell makes: environment + build for the header/footer, personal
// API tokens for the account page, external connections for settings. Mirrors Anvil's api.ts, split
// out from the editor's own ContentApi so the two stay independent.
export function defaultNexusParams() {
    return { host: "", port: 443, useSsl: true, applicationId: "", workspaceId: "", apiKey: "" };
}
export function serializeNexusParams(p) {
    return JSON.stringify(p);
}
export function defaultHarborParams() {
    return { url: "https://harbor.twist-apps.com", apiKey: "", gameId: "" };
}
export function serializeHarborParams(p) {
    return JSON.stringify({ url: p.url.trim(), apiKey: p.apiKey.trim(), gameId: p.gameId.trim() });
}
async function call(url, init) {
    const response = await fetch(url, { credentials: "same-origin", ...init });
    if (!response.ok) {
        // Surface the server's own message when it sent one — its refusals say something useful
        // ("Name is required"), and "HTTP 400" does not.
        let detail = "";
        try {
            const body = await response.json();
            detail = body?.error ?? "";
        }
        catch {
            /* not JSON — fall back to the status */
        }
        throw new Error(detail || `HTTP ${response.status}`);
    }
    return response.status === 204 ? undefined : (await response.json());
}
const json = (body) => ({
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
});
export const fetchEnvironment = () => call("/api/system/environment");
export const fetchBuildInfo = () => call("/api/system/build-info");
export const fetchTokens = () => call("/api/auth/tokens");
export const createToken = (name) => call("/api/auth/tokens", json({ name }));
export const revokeToken = (id) => call(`/api/auth/tokens/${id}`, { method: "DELETE" });
export const fetchColorPresets = () => call("/api/settings/color-presets");
export const createColorPreset = (name, colors) => call("/api/settings/color-presets", json({ name, colors }));
export const updateColorPreset = (id, name, colors) => call(`/api/settings/color-presets/${id}`, { ...json({ name, colors }), method: "PUT" });
export const deleteColorPreset = (id) => call(`/api/settings/color-presets/${id}`, { method: "DELETE" });
export const selectColorPreset = (id) => call(`/api/settings/color-presets/${id}/select`, { method: "POST" });
export const fetchConnections = () => call("/api/settings/connections");
export const createConnection = (name, type, parameters) => call("/api/settings/connections", json({ name, type, parameters }));
export const deleteConnection = (id) => call(`/api/settings/connections/${id}`, { method: "DELETE" });
export const checkConnection = (id) => call(`/api/settings/connections/${id}/check`, { method: "POST" });
